module.exports = __webpack_public_path__ + "img/icon-moderate.49d9e0c5.svg";